import { render, staticRenderFns } from "./Southbay.vue?vue&type=template&id=37fa7df0&scoped=true&"
import script from "./Southbay.vue?vue&type=script&lang=js&"
export * from "./Southbay.vue?vue&type=script&lang=js&"
import style0 from "./Southbay.vue?vue&type=style&index=0&id=37fa7df0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fa7df0",
  null
  
)

export default component.exports